import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";


// SECTION: AUTH THUNKS

// NOTE: Admin Signin
export const signin = createAsyncThunk("auth/signin/remixerUser", async (data) => {
  const response = await api.post("auth/signin/remixerUser", data);
  return response.data;
});

// NOTE: Authenticated link for resetting password
export const resetPassword = createAsyncThunk(
  "auth/reset/password",
  async (data) => {
    const response = await api.post("auth/forgot-password-remixer", data);
    return response.data;
  }
);

// NOTE: Validating the generated authenticaion token for password reset
export const validateToken = createAsyncThunk(
  "auth/validate/token",
  async ({ id, token }) => {
    const response = await api.get(`auth/verify-forgot-remixer/${id}/${token}`);
    return response.data;
  }
);

// NOTE: Resetting the password
export const updatePassword = createAsyncThunk(
  "auth/update/password",
  async ({ id, token, data }) => {
    const response = await api.post(
      `auth/change-password/${id}/${token}`,
      data
    );
    return response.data;
  }
);

// NOTE: Edit Admin Profile
export const updateAdminProfile = createAsyncThunk(
  "auth/update/admin/profile",
  async (data) => {
    const response = await api.put("user/admin/profile", data);
    return response.data;
  }
);

// NOTE: Edit Admin Password
export const updateAdminPassword = createAsyncThunk(
  "auth/update/admin/password",
  async (data) => {
    console.log("Password thunk hit");
    const response = await api.patch("user/admin/password", data);
    return response.data;
  }
);